<template>
  <main-layout selectedMenu="home">
    <div class="contestEnter">
      <div class="contest-wrap">
        <div class="geekBanner">
          <div class="do-banner1">
            <img
              :src="
                ($language === 'zh'
                  ? matchObject.zhPcBannerImage
                  : matchObject.enPcBannerImage || matchObject.zhPcBannerImage)
                  | imageUrl
              "
              alt
            />
          </div>
          <div class="nav">
            <h3 id="nav">
              {{ $t("global.提交作品") }}
              <small class="baroads" @click="close">{{
                $t("global.返回首页")
              }}</small>
            </h3>
            <ul class="step-list">
              <li
                :class="{ selected: page === 0 }"
                @click="changeStep(0)"
                v-if="isYunyi"
              >
                <a href="javascript:;" :class="{ already: stepStatus > 0 }">
                  <span class="number" v-if="stepStatus > 0">
                    <img src="/static/icon_tick_green.png" alt />
                  </span>
                  <span class="number" v-else>1</span>
                  {{ $t("works.实名认证") }}
                </a>
              </li>
              <li class="line" v-if="isYunyi"></li>
              <li :class="{ selected: page === 1 }" @click="changeStep(1)">
                <a href="javascript:;" :class="{ already: stepStatus > 1 }">
                  <span class="number" v-if="stepStatus > 1">
                    <img src="/static/icon_tick_green.png" alt />
                  </span>
                  <span class="number" v-else>{{ isYunyi ? 2 : 1 }}</span>
                  {{ $t("global.完善个人资料") }}
                </a>
              </li>
              <li class="line"></li>
              <li
                :class="{ selected: page === 2 }"
                @click="changeStep(2)"
                v-if="isJinjiang"
              >
                <a href="javascript:;" :class="{ already: stepStatus > 2 }">
                  <span class="number" v-if="stepStatus > 2">
                    <img src="/static/icon_tick_green.png" alt />
                  </span>
                  <span class="number" v-else>{{ isYunyi ? 3 : 2 }}</span>
                  {{ $t("video.下载资源包") }}
                </a>
              </li>
              <li
                :class="{ selected: page === 2 }"
                @click="changeStep(2)"
                v-if="!isJinjiang"
              >
                <a href="javascript:;" :class="{ already: stepStatus > 2 }">
                  <span class="number" v-if="stepStatus > 2">
                    <img src="/static/icon_tick_green.png" alt />
                  </span>
                  <span class="number" v-else>{{ isYunyi ? 3 : 2 }}</span>
                  {{ $t("global.上传作品") }}
                </a>
              </li>
              <li class="line" v-if="!isJinjiang"></li>
              <li
                :class="{ selected: page === 3 }"
                @click="changeStep(3)"
                v-if="!isJinjiang"
              >
                <a href="javascript:;" :class="{ already: stepStatus > 3 }">
                  <span class="number" v-if="stepStatus > 3">
                    <img src="/static/icon_tick_green.png" alt />
                  </span>
                  <span class="number" v-else>{{ isYunyi ? 4 : 3 }}</span>
                  {{ $t("global.填写参赛信息") }}
                </a>
              </li>
              <!-- <li class="line" v-if="contestName==='NewMediaArtof2020SuccessfulDesignAwards'"></li>
              <li
                :class="{selected:page === 4}"
                @click="changeStep(4)"
                v-if="contestName==='NewMediaArtof2020SuccessfulDesignAwards'"
              >
                <a href="javascript:;" :class="{'already':stepStatus>4}">
                  <span v-if="stepStatus>4">
                    <img src="/static/icon_tick_green.png" alt />
                  </span>
                  <span v-else>4</span>
                  {{$t('global.支付费用')}}
                </a>
              </li>-->
            </ul>
          </div>
        </div>
        <!--view-->
        <div class="container">
          <!-- <step0
            ref="step0"
            v-show="page === 0"
            :personalDetail="personalDetail"
            :status="status"
            @callback="callbackStep0"
          /> -->
          <step1
            ref="step1"
            v-show="page === 1"
            :matchId="matchObject.id"
            :matchShow="matchObject.showStudentInfo"
            :matchProperty="matchObject.matchProperty"
            :peopleMessage="userInfo"
            @callback="callbackStep"
          />
          <step2
            ref="step2"
            :matchId="matchObject.id"
            :imageCount="matchObject.minImageNum"
            :matchProperty="matchObject.matchProperty"
            :fileDesZh="matchObject.fileDesZh"
            :fileDesEn="matchObject.fileDesEn"
            v-show="page === 2 && !isJinjiang"
            @callback="callbackStep2"
          />
          <!-- <step5
            ref="step5"
            :matchId="matchObject.id"
            :matchKey="matchObject.resourcePackage"
            v-show="page === 2 && isJinjiang"
          /> -->
          <step3
            ref="step3"
            :matchId="matchObject.id"
            :pageId="matchObject.matchRuleId"
            :videoId="videoId"
            :num="matchObject.categoryMaxCount"
            :peopleMessage="userInfo"
            v-show="page === 3"
            @callback="callbackStep3"
            :hasSubmit="hasSubmit"
          />
          <!-- <step4
            ref="step4"
            v-show="page === 4"
            :price="matchObject.price"
            :videoId="videoId"
          /> -->
          <div
            class="dialog-footer"
            v-if="
              isYunyi
                ? page === 0 ||
                  page === 1 ||
                  page === 2 ||
                  (page === 3 && !hasSubmit)
                : page === 1 || page === 2 || (page === 3 && !hasSubmit)
            "
          >
            <el-button @click="close">{{ $t("global.取 消") }}</el-button>
            <span v-if="!isJinjiang" style="margin-left: 10px">
              <el-button
                type="primary"
                @click="nextStep"
                v-if="
                  page !== 3 ||
                  contestName === 'NewMediaArtof2020SuccessfulDesignAwards'
                "
                >{{ $t("global.下一步") }}</el-button
              >
              <el-button type="primary" @click="nextStep3" v-else>{{
                $t("global.提交")
              }}</el-button>
            </span>
            <span v-if="isJinjiang" style="margin-left: 10px">
              <el-button type="primary" @click="nextStep" v-if="page == 1">{{
                $t("global.下一步")
              }}</el-button>
              <el-button type="primary" @click="gotoSignup" v-if="page == 2">{{
                $t("global.立即报名")
              }}</el-button>
            </span>
          </div>
        </div>
      </div>
    </div>
  </main-layout>
</template>

<script>
import "./css/lifePz.css";
import MainLayout from "@/layouts/MainLayout";
import step0 from "@/pages/match/contestEnterStep/step0";
import step1 from "@/pages/match/contestEnterStep/step1";
import step2 from "@/pages/match/contestEnterStep/step2";
import step3 from "@/pages/match/contestEnterStep/step3";
import step4 from "@/pages/match/contestEnterStep/step4";
import step5 from "@/pages/match/contestEnterStep/step5";

export default {
  name: "IndexPage",
  metaInfo() {
    return {
      title: this.$t("global.提交作品") + " | MANA",
    };
  },
  components: {
    MainLayout,
    step0,
    step1,
    step2,
    step3,
    step4,
    step5,
  },
  data() {
    return {
      hasSubmit: false,
      contestName: -1,
      /**
       * isInternational:1 $t('global.国际')
       * isInternational:2 $t('global.非国际')
       */
      matchObject: {},
      dialogFormVisible: false,
      step: 0,
      page: 1,
      stepStatus: 1,
      videoId: null,
      userInfo: {},
      status: null,
      personalDetail: null,
      isYunyi: false,
      isJinjiang: false,
    };
  },
  created() {
    this.init();
    if (this.$query.name && this.$query.name == "jinjiang") {
      this.isJinjiang = true;
    } else {
      this.isJinjiang = false;
    }
    this.userInfo = this.$store.state.peopleMessage;
  },
  mounted() {
    this.$nextTick(() => {
      document.getElementById("nav").scrollIntoView(true);
    });
  },
  computed: {
    language() {
      return this.$language();
    },
  },
  watch: {
    page(val) {
      if (val == 0) {
        this.$http.get("/api/u/certification/company/get").then((res) => {
          if (res.data.status == 2) {
            this.status = 2;
          } else {
            this.$http
              .get("/api/u/certification/personal/get")
              .then((response) => {
                let data = response.data;
                this.status = data.status;
                this.personalDetail = data;
              });
          }
        });
      }
    },
    $route(val) {
      if (val.query && val.query.name == "jinjiang") {
        this.isJinjiang = true;
      } else {
        this.isJinjiang = false;
      }
    },
  },
  methods: {
    init() {
      const videoId = this.$query.videoId;
      if (videoId) {
        if (Number.isNaN(Number(videoId))) {
          location.assign(decodeURIComponent(location.href));
          return;
        }
        const step = this.$query.step;
        this.videoId = videoId;
        this.page = 3;
        this.stepStatus = 4;
        if (step) {
          this.page = +step;
        }
      }
      this.contestName = this.$route.params.contestName;
      if (this.contestName) {
        this.$http
          .get("/api/nmatch/url/" + this.contestName)
          .then((response) => {
            if (response.code === "OK") {
              if (response.data.matchState !== 2) {
                this.$message.error(this.$t("works.该竞赛已结束！"));
                setTimeout(() => {
                  this.$router.push("/activity/match");
                }, 1000);
              }
              this.matchObject = response.data;
              if (this.matchObject.id == 1027) {
                this.isYunyi = true;
                if (!this.videoId) {
                  this.stepStatus = 0;
                  this.page = 0;
                }
                this.personalMessage();
              } else {
                this.isYunyi = false;
                this.checkInformation();
              }
              document.title = response.data.title;
            }
          });
      }
    },
    gotoSignup() {
      this.$router.push(`/match/${this.contestName}/enter`);
    },
    personalMessage() {
      this.$http.get("/api/u/certification/company/get").then((res) => {
        if (res.data.status == 2) {
          this.status = 2;
          this.checkInformation();
        } else {
          this.$http
            .get("/api/u/certification/personal/get")
            .then((response) => {
              let data = response.data;
              this.status = data.status;
              this.personalDetail = data;
              this.checkInformation();
            });
        }
      });
    },
    checkInformation() {
      const url = `/api/match/user/checkIsSelfImprovement`;
      const params = {
        userId: this.$store.state.peopleMessage.userId,
        matchId: this.matchObject.id,
      };
      this.$http.get(url, { params }).then((res) => {
        if (res.code === "OK") {
          var object = res.data;
          if (this.matchObject.id == 1027) {
            if (this.status == 2 || this.status == 1) {
              if (object.school && object.address && object.wechatLink) {
                if (object.isGraduation == 2) {
                  if (object.leartPhase) {
                    if (this.videoId) {
                      this.page = 3;
                      this.stepStatus = 4;
                    } else {
                      this.page = 2;
                      this.stepStatus = 2;
                    }
                  } else {
                    this.page = 1;
                    this.stepStatus = 1;
                  }
                } else {
                  if (this.videoId) {
                    this.page = 3;
                    this.stepStatus = 4;
                  } else {
                    this.page = 2;
                    this.stepStatus = 2;
                  }
                }
              } else {
                this.page = 1;
                this.stepStatus = 1;
              }
            } else {
              this.page = 0;
              this.stepStatus = 0;
            }
          } else {
            if (this.videoId) {
              this.page = 3;
              this.stepStatus = 4;
            } else {
              if(!object.wechatLink){
                this.page = 1;
                this.stepStatus = 1;
              }
              else if (this.matchObject.id == 1033) {
                if (object.school) {
                  this.page = 2;
                  this.stepStatus = 2;
                } else {
                  this.page = 1;
                  this.stepStatus = 1;
                }
              } else {
                this.page = 2;
                this.stepStatus = 2;
              }
            }
          }
          this.userInfo = res.data;
        } else {
          this.page = 1;
          this.stepStatus = 1;
        }
      });
    },
    changeStep(step) {
      if (this.stepStatus >= step) {
        this.page = step;
      }
    },
    nextStep() {
      this.$refs[`step${this.page}`].submit();
    },
    nextStep3() {
      this.$refs[`step${this.page}`].submitNormal();
    },
    callbackStep0() {
      if (this.page == this.stepStatus) {
        this.stepStatus++;
      }
      this.page++;
    },
    callbackStep() {
      if (this.page == this.stepStatus) {
        this.stepStatus++;
      }
      this.page++;
    },
    callbackStep3() {
      this.hasSubmit = true;
    },
    callbackStep2(videoId) {
      if (videoId) {
        this.videoId = videoId;
        this.stepStatus++;
        this.page++;
      }
    },
    close() {
      this.$router.push(`/match/${this.contestName}/home`);
    },
  },
};
</script>

<style lang="stylus" scoped>
.contestEnter {
  min-height: calc(100vh - 210px);

  .contest-wrap {
    overflow: hidden;
    position: relative;
    background: #f5f5f5;

    .geekBanner {
      background: #fff;

      // height: 460px;
      .do-banner1 {
        width: 100%;
        height: auto;
        overflow: hidden;
        display: flex;
        justify-content: center;

        img {
          display: block;
          max-width: 2880px;
        }
      }

      .nav {
        // position: absolute;
        // top: 300px;
        display: block;
        width: 100%;
        padding: 30px 0 20px;
        height: 130px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);

        h3 {
          width: 1160px;
          margin: 0 auto;
          height: 40px;
          font-size: 28px;
          color: #333;
          line-height: 40px;

          small {
            display: inline-block;
            width: 144px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            color: #333333;
            font-size: 16px;
            border: 1px solid rgba(153, 153, 153, 1);
            float: right;
            cursor: pointer;
          }
        }

        .step-list {
          width: 100%;
          margin: 0 auto;
          display: --webkit-flex;
          display: flex;
          justify-content: center;
          flex-direction: row;
          padding-top: 50px;
          font-size: 0;

          li {
            height: 25px;
            font-size: 18px;
            line-height: 25px;
            text-align: center;
            display: inline-block;

            &.selected {
              a {
                color: #0A0A0A;
                font-weight: 600;
              }

              span {
                border: 1px solid #0A0A0A;
              }
            }

            span {
              display: inline-block;
              width: 24px;
              height: 24px;
              line-height: 24px;
              border: 1px solid #999999;
              border-radius: 50%;
              text-align: center;
              vertical-align: bottom;

              img {
                display: inline-block;
                width: 12px;
                height: 12px;
                vertical-align: middle;
              }
            }

            span.number {
              font-size: 12px;
              font-family: Nunito Sans;
              font-weight: bold;
            }

            a {
              color: #999999;

              &.already {
                color: #1FCD72;

                span {
                  border: 1px solid #1FCD72;
                }
              }
            }
          }

          li.line {
            height: 2px;
            width: 10%;
            // border-bottom: 1px dotted #E0E0E0;
            background: url('/static/step_line.png') no-repeat center;
            margin: 12px 30px 0;
            vertical-align: top;
          }
        }
      }
    }

    .container {
      width: 1160px;
      margin: 20px auto 0;
      padding-bottom: 20px;
      background: #fff;
      padding: 40px 0;
      box-sizing: border-box;

      .dialog-footer {
        text-align: center;
        padding: 30px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/match/ContestEnter.vue